@if(error) {
  <div class="alert alert-danger">{{error}}</div>
}
<h1 data-automation-name="platformEditor">
  @switch(editing) {
    @case(true) {
      <span>Edit Platform {{platformId}}</span>
    }
    @case(false) {
      <span>Register a new Platform</span>
    }
  }
</h1>
<form name="platformForm" class="form-horizontal" [formGroup]="platformForm">
  <div class="form-group">
    <label for="platformId"> Environment: </label>
    <input id="platformId" class="form-control" name="id" type="text" formControlName="environment" required>
    @if(platformForm.get('environment')?.invalid && (platformForm.get('environment')?.dirty || platformForm.get('environment')?.touched)) {
      <div class="text-danger">
        <div *ngIf="platformForm.get('environment')?.errors?.['required']">Environment is required.</div>
      </div>
    }
  </div>

  <div>
    <div class="panel-heading">
      <div class="form-group">
        <label for="x_energy_enabled" class="form-check-label">X-Energy Enabled?</label>
        <br/>
        <input id="x_energy_enabled" class="form-check-input" name="x_energy_enabled" type="checkbox" formControlName="x_energy_enabled">
      </div>
    </div>
    @if(!platformForm.get('x_energy_enabled')?.value) {
      <div class="panel-body">
        <div class="form-group">
          <label for="amqphost"> Amqp host: (for example 'amqpserver.net//FAS') </label>
          <input id="amqphost" class="form-control" name="amqp_host" type="text" formControlName="amqp_host" required>
          @if(platformForm.get('amqp_host')?.invalid && (platformForm.get('amqp_host')?.dirty || platformForm.get('amqp_host')?.touched)) {
            <div class="text-danger">
              <div *ngIf="platformForm.get('amqp_host')?.errors?.['required']">AMQP host is required when X-Energy is disabled.</div>
            </div>
          }
        </div>
        <div class="form-group">
          <label for="platformAmqp_user"> Amqp user: </label>
          <input id="platformAmqp_user" class="form-control" name="amqp_user" type="text" formControlName="amqp_user" required>
          @if(platformForm.get('amqp_user')?.invalid && (platformForm.get('amqp_user')?.dirty || platformForm.get('amqp_user')?.touched)) {
            <div class="text-danger">
              <div *ngIf="platformForm.get('amqp_user')?.errors?.['required']">AMQP user is required when X-Energy is disabled.</div>
            </div>
          }
        </div>
        <div class="form-group">
          <label for="platformAmqp_pass"> Amqp password: </label>
          <input id="platformAmqp_pass" class="form-control" name="amqp_pass" type="password" formControlName="amqp_pass" required>
          @if(platformForm.get('amqp_pass')?.invalid && (platformForm.get('amqp_pass')?.dirty || platformForm.get('amqp_pass')?.touched)) {
            <div class="text-danger">
              <div *ngIf="platformForm.get('amqp_pass')?.errors?.['required']">AMQP password is required when X-Energy is disabled.</div>
            </div>
          }
        </div>

        <div class="form-group">
          <label for="platformExchange"> Exchange: </label>
          <input id="platformExchange" class="form-control" name="exchange" type="text" formControlName="exchange" required>
          @if(platformForm.get('exchange')?.invalid && (platformForm.get('exchange')?.dirty || platformForm.get('exchange')?.touched)) {
            <div class="text-danger">
              <div *ngIf="platformForm.get('exchange')?.errors?.['required']">Exchange is required when X-Energy is disabled.</div>
            </div>
          }
        </div>
        <div class="form-group">
          <label for="platformRouting_key"> Routing key: </label>
          <input id="platformRouting_key" class="form-control" name="routing_key" type="text" formControlName="routing_key" required>
          @if(platformForm.get('routing_key')?.invalid && (platformForm.get('routing_key')?.dirty || platformForm.get('routing_key')?.touched)) {
            <div class="text-danger">
              <div *ngIf="platformForm.get('routing_key')?.errors?.['required']">Routing key is required when X-Energy is disabled.</div>
            </div>
          }
        </div>
      </div>
    }
  </div>
  <div class="row">
    <button id="save" class="btn btn-primary" type="button" (click)="save()" [disabled]="platformForm.invalid">Save</button>
    <a class="btn" (click)="backPage('/platforms', router)">Cancel</a>
  </div>
</form>
